import React, { memo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { Box } from '@mui/material';
import ErrorHandlingLayout from '@sharedCR/common/ErrorHandlingLayout';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';
import { compose } from 'redux';

import usePendingChangesDependentFetch from 'hooks/usePendingChangesDependentFetch';

import { getLoanSummaryAction } from 'store/loanApplications/actions';

import { containerStyles, wrapperStyles } from './LoanSummary.styles';
import LoanSummaryInformation from './LoanSummaryInformation';
import SubmissionReadinessPanel from './SubmissionReadinessPanel';

const LoanSummary = ({ isLoading, setIsLoading }) => {
  const dispatch = useDispatch();
  const { applicationId } = useParams();

  const [isError, setIsError] = useState(false);

  const fetchData = useCallback(() => {
    setIsError(false);
    setIsLoading(true);

    Promise.all([dispatch(getLoanSummaryAction({ applicationId }))])
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false));
  }, [applicationId, dispatch, setIsLoading]);

  usePendingChangesDependentFetch(fetchData);

  return (
    <ErrorHandlingLayout isError={isError} onClick={fetchData}>
      <Box sx={containerStyles}>
        <SubmissionReadinessPanel applicationId={applicationId} />
        <Box sx={wrapperStyles}>
          <LoanSummaryInformation isLoading={isLoading || isError} />
        </Box>
      </Box>
    </ErrorHandlingLayout>
  );
};

LoanSummary.propTypes = {
  ...WithLoadingPropTypes,
};

export default compose(withLoading, memo)(LoanSummary);
